import {URL_BASE_API } from '../../../configs/urlConfigs'; 

import service from '../../api';

export const aflt_appayrateList = (request) => {
    let ENDPOINT = '';
    ENDPOINT = URL_BASE_API+'affiliate/ap-points/'; // ?column=ap_from'; 
    return service.get(ENDPOINT);    
};

export const aflt_appayrateAdd = (request) => {
  const ENDPOINT = URL_BASE_API+'affiliate/ap-points/';
  return service.post(ENDPOINT,request.data);  
}; 

export const aflt_appayrateUpdate = (request) => {
  let appayrateId = request.data.id;
  const ENDPOINT = URL_BASE_API+'affiliate/ap-points/'+appayrateId;
  return service.put(ENDPOINT,request.data);
};

export const aflt_appayrateDelete = (request) => {
  const ENDPOINT = URL_BASE_API+'affiliate/ap-points/'+request.data;
  return service.delete(ENDPOINT);  
};  

